/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { AuditReportsStructuredJobProgressDto } from "./AuditReportsStructuredJobProgressDto";

export const AuditReportsPublicJobDtoStatusEnum = {
    SCHEDULED: "SCHEDULED",
    WAITING: "WAITING",
    WAITING_CHILDREN: "WAITING_CHILDREN",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED"
} as const;

export type AuditReportsPublicJobDtoStatusEnumKey = (typeof AuditReportsPublicJobDtoStatusEnum)[keyof typeof AuditReportsPublicJobDtoStatusEnum];

export type AuditReportsPublicJobDto = {
    /**
     * @description Unique identifier of the job
     * @type string
    */
    id: string;
    /**
     * @description BullMQ job name (typically the job class name). Omitted on snapshots persisted before this field existed.
     * @type string | undefined
    */
    name?: string;
    /**
     * @description Current status of the job
     * @type string
    */
    status: AuditReportsPublicJobDtoStatusEnumKey;
    /**
     * @description Whether the job is still pending (scheduled, waiting, or in progress)
     * @type boolean
    */
    isPending: boolean;
    /**
     * @description Whether the job has finished (completed, failed, or cancelled)
     * @type boolean
    */
    isFinished: boolean;
    /**
     * @description Raw progress value (number or object). Prefer progressPercent and progressData.
     * @deprecated
    */
    progress?: (number | object);
    /**
     * @description Timestamp when the progress was last updated
     * @type string | undefined
    */
    progressUpdatedAt?: string;
    /**
     * @description Normalized progress percentage (0–100), derived from progress when available
     * @type number | undefined
    */
    progressPercent?: number;
    /**
     * @description Normalized structured progress payload when progress is an object; null/omitted for numeric progress
    */
    progressData?: AuditReportsStructuredJobProgressDto;
    /**
     * @description Timestamp when the job was created (enqueued). Omitted on snapshots persisted before this field existed.
     * @type string | undefined
    */
    createdAt?: string;
    /**
     * @description Timestamp when a delayed job is expected to become runnable (createdAt + delay). Omitted when the job has no delay.
     * @type string | undefined
    */
    scheduledAt?: string;
    /**
     * @description Timestamp when job processing started. Omitted until the job has been picked up by a worker.
     * @type string | undefined
    */
    processedOn?: string;
    /**
     * @description Timestamp when the job was finished (completed, failed, or cancelled)
     * @type string | undefined
    */
    finishedOn?: string;
};